import axios from '../axios'

/* 
 * 分类模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/category/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/category/delete',
        method: 'post',
        data
    })
}
// 查询
export const findPage = (data) => {
    return axios({
        url: '/category/findPage',
        method: 'post',
        data
    })
}

// 查询
export const findPageAll = (data) => {
    return axios({
        url: '/category/findPageAll',
        method: 'post',
        data
    })
}
export const getSort = (data) => {
    return axios({
        url: '/category/getSort',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/category.js